import { render, staticRenderFns } from "./tplAdd.vue?vue&type=template&id=2169678b&scoped=true"
import script from "./tplAdd.vue?vue&type=script&lang=js"
export * from "./tplAdd.vue?vue&type=script&lang=js"
import style0 from "./tplAdd.vue?vue&type=style&index=0&id=2169678b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2169678b",
  null
  
)

export default component.exports